import {Button, Spin, Upload, UploadFile, UploadProps, message} from "antd";
import {useSelector} from "react-redux";
import {CloudUploadOutlined, PictureOutlined} from "@ant-design/icons";
import {useState} from "react";
import {UploadChangeParam} from "antd/lib/upload";
import type {RcFile} from "antd/es/upload/interface";
import ImgCrop from "antd-img-crop";
import {RootState} from "../../../../../../redux/store";
import {useGetProfileContext} from "../../../../../../context/profile/profile-context";
import {API_BASE_URL_V2} from "../../../../../../services/config";
import {LoadingSpinner} from "../../../../../../components/icons/icons";
import {StyledProfileCoverImageWrapper} from "./styles";
import {LEGACY_PROFILE_QUERY_KEY} from "../../../../../../features/profile/hooks/useProfile";
import {useQueryClient} from "@tanstack/react-query";

type CoverImageUploadStatus = "idle" | "pending" | "resolved" | "rejected";

export function ProfileCoverImageFormField() {
  const queryClient = useQueryClient();
  const {
    state: {
      profileData: {cover_image},
    },
  } = useGetProfileContext();
  const {userInfo} = useSelector((state: RootState) => state.userLogin);
  const [coverImageUploadStatus, setCoverImageUploadStatus] =
    useState<CoverImageUploadStatus>("idle");

  const beforeUpload = async (file: RcFile) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image must smaller than 5MB!");
    }
    return isLt5M;
  };

  const handleImageChange: UploadProps["onChange"] = (
    info: UploadChangeParam<UploadFile>
  ) => {
    // console.log(info);
    if (info.file.status === "uploading") {
      setCoverImageUploadStatus("pending");
      return;
    }
    if (info.file.status === "error") {
      setCoverImageUploadStatus("rejected");
      message.error(info.file.response.message);
      return;
    }

    if (info.file.status === "done") {
      queryClient.invalidateQueries({queryKey: [LEGACY_PROFILE_QUERY_KEY]});
      setCoverImageUploadStatus("resolved");
      message.success("Your cover image has been uploaded successfully!");
    }
  };
  return (
    <Spin spinning={coverImageUploadStatus === "pending"} indicator={LoadingSpinner}>
      <StyledProfileCoverImageWrapper>
        <div>
          <PictureOutlined style={{fontSize: "3.6rem", color: "#BFBFBF"}} />
        </div>
        <p className="upload-text">Minimum width 480 pixels, 16:9 recommended</p>
        <div>
          <ImgCrop rotationSlider aspect={1.9}>
            <Upload
              name="cover-image"
              // showUploadList={false}
              headers={{
                authorization: `Bearer ${userInfo?.accessToken}`,
              }}
              action={`${API_BASE_URL_V2}profile/cover-image`}
              onChange={handleImageChange}
              beforeUpload={beforeUpload}
              method="POST"
              listType="picture"
              maxCount={1}
              defaultFileList={
                cover_image
                  ? [
                      {
                        uid: "1",
                        name: "cover_image",
                        status: "done",
                        url: `${cover_image ?? ""}`,
                      },
                    ]
                  : undefined
              }
            >
              <Button
                style={{paddingLeft: 0}}
                type="link"
                size="small"
                icon={<CloudUploadOutlined />}
              >
                Upload cover photo
              </Button>
            </Upload>
          </ImgCrop>
        </div>
      </StyledProfileCoverImageWrapper>
    </Spin>
  );
}
